'use client';

import { produce } from 'immer';
import { createStore } from 'zustand';

import { FormDashboardFilters, FormDashboardState } from '../types/home-store-types';

export const initialFilters: FormDashboardFilters = {
	search: '',
	createdByMe: false,
	liveForms: false,
	closedForms: false,
};

export default function createFormDashboardStore(defaultState?: Partial<FormDashboardState>) {
	return createStore<FormDashboardState>((set, get) => ({
		// Initial state
		filters: defaultState?.filters || initialFilters,
		forms: defaultState?.forms || [],
		isLoadingForms: defaultState?.isLoadingForms || false,

		// Actions
		setIsLoadingForms: (isLoadingForms) => {
			set(
				produce((state: FormDashboardState) => {
					state.isLoadingForms = isLoadingForms;
				})
			);
		},
		setForms: (forms) => {
			set(
				produce((state: FormDashboardState) => {
					state.forms = forms;
				})
			);
		},
		updateForm: (form) => {
			set(
				produce((state: FormDashboardState) => {
					state.forms = state.forms.map((f) => (f.identifier === form.identifier ? form : f));
				})
			);
		},
		deleteForm: (formId) => {
			set(
				produce((state: FormDashboardState) => {
					state.forms = state.forms.filter((f) => f.identifier !== formId);
				})
			);
		},
		setFilters: (filters) => {
			set(
				produce((state: FormDashboardState) => {
					state.filters = { ...state.filters, ...filters };
				})
			);
		},

		resetFilters: () => {
			set(
				produce((state: FormDashboardState) => {
					state.filters = initialFilters;
				})
			);
		},

		getState: () => get(),
	}));
}
